import { render } from "./ReportsTable.vue?vue&type=template&id=89a3c55a&scoped=true"
import script from "./ReportsTable.vue?vue&type=script&lang=js"
export * from "./ReportsTable.vue?vue&type=script&lang=js"

import "./reports-table.scss?vue&type=style&index=0&id=89a3c55a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a3c55a"]])

export default __exports__